import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.promise.finally.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'CookieControl',
  props: {
    locale: {
      default: 'en'
    }
  },
  data: function data() {
    return {
      saved: true,
      colorsSet: false,
      cookies: this.$cookies
    };
  },
  computed: {
    expirationDate: function expirationDate() {
      var date = new Date();
      date.setFullYear(date.getFullYear() + 1);
      return date.toUTCString();
    },
    optionalCookies: function optionalCookies() {
      return this.cookies.optional;
    }
  },
  methods: {
    toogleCookie: function toogleCookie(cookie) {
      var cookieName = cookie.identifier || this.cookies.slugify(this.getCookieFirstName(cookie.name));
      if (this.saved) this.saved = false;
      if (!this.cookies.enabledList.includes(cookieName)) this.cookies.enabledList.push(cookieName);else this.cookies.enabledList.splice(this.cookies.enabledList.indexOf(cookieName), 1);
    },
    setConsent: function setConsent(_ref) {
      var _this = this;

      var type = _ref.type,
          _ref$consent = _ref.consent,
          consent = _ref$consent === void 0 ? true : _ref$consent,
          _ref$reload = _ref.reload,
          reload = _ref$reload === void 0 ? true : _ref$reload,
          _ref$declineAll = _ref.declineAll,
          declineAll = _ref$declineAll === void 0 ? false : _ref$declineAll;
      this.cookies.set({
        name: 'cookie_control_consent',
        value: consent,
        expires: this.expirationDate
      });
      var enabledCookies = declineAll ? [] : type === 'partial' && consent ? this.cookies.enabledList : _toConsumableArray(this.optionalCookies.map(function (c) {
        return c.identifier || _this.cookies.slugify(_this.getCookieFirstName(c.name));
      }));
      this.cookies.set({
        name: 'cookie_control_enabled_cookies',
        value: consent ? enabledCookies.join(',') : '',
        expires: this.expirationDate
      });

      if (!reload) {
        this.cookies.setConsent();
        this.$cookies.modal = false;
      } else window.location.reload(true);
    },
    getDescription: function getDescription(description) {
      if (typeof description === 'string') return " ".concat(this.cookies.dashInDescription !== false ? '-' : '', " ").concat(description);else if (description[this.locale]) return " ".concat(this.cookies.dashInDescription !== false ? '-' : '', " ").concat(description[this.locale]);
      return '';
    },
    getName: function getName(name) {
      return name === 'functional' ? this.cookies.text['functional'] : typeof name === 'string' ? name : name[this.locale] ? name[this.locale] : name[Object.keys(name)[0]];
    },
    getCookieFirstName: function getCookieFirstName(name) {
      return typeof name === 'string' ? name : name[Object.keys(name)[0]];
    },
    setTexts: function setTexts() {
      var _arguments = arguments,
          _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var isChanged, text, module;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                isChanged = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : false;
                text = null;
                module = null;

                try {
                  module = require("../locale/".concat(_this2.locale));
                } catch (e) {
                  module = require("../locale/en");
                }

                text = module.default;

                if (_this2.cookies.text && Object.keys(_this2.cookies.text).length > 0) {
                  if (_this2.cookies.text.locale) {
                    Object.assign(text, _this2.cookies.text.locale[_this2.locale]);
                  }

                  if (!isChanged) Object.assign(text, _this2.cookies.text);
                }

                _this2.$set(_this2.$cookies, 'text', text);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  },
  beforeMount: function beforeMount() {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var key, variables, k, module, cssVars, cssVar;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this3.setTexts();

            case 2:
              if (!(process.browser && _this3.cookies.colors)) {
                _context2.next = 15;
                break;
              }

              key = null;
              variables = {};

              for (key in _this3.cookies.colors) {
                k = key.toLowerCase().includes('unactive') ? key.replace(/Unactive/g, 'Inactive') : key;
                variables["cookie-control-".concat(k)] = "".concat(_this3.cookies.colors[key]);
              }

              if (!_this3.cookies.cssPolyfill) {
                _context2.next = 14;
                break;
              }

              _context2.next = 9;
              return import('css-vars-ponyfill');

            case 9:
              module = _context2.sent;
              cssVars = module.default;
              cssVars({
                variables: variables
              });
              _context2.next = 15;
              break;

            case 14:
              if (process.client && _this3.cookies.css) {
                for (cssVar in variables) {
                  document.documentElement.style.setProperty("--".concat(cssVar), variables[cssVar]);
                }
              }

            case 15:
              if (!_this3.cookies.get('cookie_control_consent') || _this3.cookies.get('cookie_control_consent').length === 0) {
                _this3.optionalCookies.forEach(function (c) {
                  if (c.initialState === true) {
                    _this3.cookies.enabledList.push(c.identifier || _this3.cookies.slugify(_this3.getCookieFirstName(c.name)));
                  }
                });
              }

              _this3.colorsSet = true;

            case 17:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  watch: {
    locale: function locale() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this4.setTexts(true);

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  }
};